var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-hc-selector"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('finalThanksHolidayCheckIntro'))}}),_vm._v(" "),_c('button',{staticClass:"cst-survey-btn-finish",on:{"click":_vm.holidayCheck}},[_vm._v(_vm._s(_vm.$t('finalThanksHolidayCheckBtn')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ff9fbe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHcSelector.vue
// module id = null
// module chunks = 